import {BaseModel} from "../../../infrastructure/models/base-model";
import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";

export class BreadcrumbsItemModel extends BaseModel {
  position: Number;
  name: String;
  model: BaseLinkModel;
  item: String;
  entityType: String;
  metaDataIncluded: Boolean;

  constructor(position: Number, name: String, url: String, model: BaseLinkModel, entityType, metaDataIncluded: Boolean = true) {
    super();

    this.position = position;
    this.name = name;
    this.model = model;
    this.item = url;
    this.entityType = entityType;
    this.metaDataIncluded = metaDataIncluded
  }

  get positionParams(): String {
    return `"position":${this.position}`
  }

  get nameParams(): String {
    return `"name":${JSON.stringify(this.name ?? '')}`
  }

  get itemParams(): String {
    return `"item":"${this.item}"`
  }

  get entityId(): Number {
    return this.model.params?.id || this.model.params?.matchupId
  }

  toString(): String {
    return `{"@type":"ListItem", ${this.positionParams}, ${this.nameParams}, ${this.itemParams}}`;
  }
}
